import { connect } from 'react-redux'
import Login from '../components/Login.js'
import { handleEvent, LogIn } from '../modules/login.js'
import { SetRememberMe } from '../../../modules/global.js'
const mapStateToProps = state => ({
  ...state.Login
})

const mapDispatchToProps = {
  handleEvent,
  LogIn,
  SetRememberMe
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
